var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "table",
    {
      staticClass:
        "table product-collection-table thead-no-border table-striped table-hover thead-sticky",
      attrs: { id: _vm.id },
    },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.fields, function (field) {
            return _c(
              "th",
              { key: field.key, class: field.class || "" },
              [
                field.key === "name"
                  ? [
                      _vm.action === "toggle"
                        ? [
                            _c("span", {
                              staticClass:
                                "mdi mdi-compare-horizontal mdi-24px",
                            }),
                          ]
                        : _vm._e(),
                    ]
                  : field.key === "performance"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { id: "period-switcher" },
                        },
                        [
                          _c("span", {
                            domProps: { textContent: _vm._s(field.label) },
                          }),
                          _c(
                            "ci-dropdown-menu",
                            {
                              staticClass: "d-none d-lg-block",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function () {
                                      return [
                                        _c("span", {
                                          staticClass:
                                            "mdi mdi-24px mdi-menu-down",
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("ci-dropdown-item", {
                                attrs: {
                                  name: _vm.$tc(
                                    "ui.shared.global.metrics.periods.year.long",
                                    1,
                                    { period: 1 }
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit(
                                      "performance-period-changed",
                                      "performance_1_year"
                                    )
                                  },
                                },
                              }),
                              _c("ci-dropdown-item", {
                                attrs: {
                                  name: _vm.$tc(
                                    "ui.shared.global.metrics.periods.year.long",
                                    3,
                                    { period: 3 }
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit(
                                      "performance-period-changed",
                                      "performance_3_years"
                                    )
                                  },
                                },
                              }),
                              _c("ci-dropdown-item", {
                                attrs: {
                                  name: _vm.$tc(
                                    "ui.shared.global.metrics.periods.year.long",
                                    5,
                                    { period: 5 }
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit(
                                      "performance-period-changed",
                                      "performance_5_years"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c("span", {
                        domProps: { textContent: _vm._s(field.label) },
                      }),
                    ],
              ],
              2
            )
          }),
          0
        ),
      ]),
      _c(
        "tbody",
        { attrs: { role: "rowgroup" } },
        _vm._l(_vm.items, function (item) {
          return _c(
            "tr",
            {
              key: item.id,
              class: _vm.highlightProduct(item) + ` product-${item.id}`,
              on: {
                mouseenter: function ($event) {
                  return _vm.rowHovered($event, item)
                },
                mouseleave: function ($event) {
                  return _vm.rowLeft($event, item)
                },
              },
            },
            _vm._l(_vm.fields, function (field) {
              return _c(
                "td",
                { key: field.key, class: field.class || "" },
                [
                  field.key === "name"
                    ? [
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row-action flex-shrink-0 d-flex align-items-center checkbox-wrapper min-h-100",
                              on: {
                                click: function ($event) {
                                  return _vm.handleComparisonToggle(
                                    item,
                                    _vm.action === "remove"
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row-action flex-shrink-0" },
                                [
                                  _vm.action === "toggle"
                                    ? [
                                        _c("ci-checkbox", {
                                          staticClass: "w-100 h-100",
                                          class: {
                                            "mediathek-padding":
                                              item.has_product_attachments,
                                          },
                                          attrs: {
                                            name: `toggle-${item.isin}`,
                                            value: _vm.comparisonProducts.some(
                                              (p) => p.id === item.id
                                            ),
                                            label: "",
                                            disabled: _vm.toggleDisabled(item),
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm.action === "remove"
                                    ? [
                                        _c("ci-button", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            icon: "mdi-delete",
                                            variant: "ghost-danger",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "row-info flex-grow-1",
                              class: {
                                "mediathek-padding":
                                  item.has_product_attachments,
                              },
                            },
                            [
                              _c(
                                "ci-router-link",
                                {
                                  staticClass:
                                    "product-collection-table__name text-dark",
                                  attrs: {
                                    to: {
                                      name: _vm.$routes.PRODUCTS_SHOW,
                                      params: { id: item.slug || item.id },
                                    },
                                    rel: "noopener",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.productClickHandler(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "h6 mb-2" },
                                    [
                                      _vm._t(
                                        "name",
                                        function () {
                                          return [
                                            _c("span", [
                                              _vm._v(_vm._s(item.name)),
                                            ]),
                                          ]
                                        },
                                        null,
                                        item
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center flex-wrap",
                                },
                                [
                                  _vm.priceUpdateBox
                                    ? _c(
                                        "div",
                                        { staticClass: "mb-1 mr-3" },
                                        [
                                          _c("ci-price-update-box", {
                                            staticClass:
                                              "font-weight-normal text-xs",
                                            attrs: {
                                              "up-to-date":
                                                item.data_up_to_date,
                                              timestamp:
                                                item.price_last_updated_at,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center flex-wrap",
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "d-block text-xs text-nowrap mr-3 mb-1",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "ui.shared.global.models.products.isin"
                                            ) +
                                              ": " +
                                              item.isin
                                          ),
                                        },
                                      }),
                                      item.sustainable_preference
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex text-xs text-nowrap align-items-center mb-1",
                                              },
                                              [
                                                _c("ci-sfdr", {
                                                  attrs: {
                                                    value:
                                                      item.sustainable_preference,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              item.peergroup && _vm.rankingLink
                                ? _c(
                                    "ci-router-link",
                                    {
                                      staticClass:
                                        "product-collection-table__ranking d-none d-md-block font-weight-semi text-nowrap",
                                      attrs: {
                                        to: {
                                          name: _vm.$routes
                                            .PRODUCTS_RANKING_INDEX,
                                          params: {
                                            product_slug: item.slug,
                                            peergroup: _vm.$parameterize(
                                              item.peergroup
                                            ),
                                          },
                                          query: { view_mode: "chart" },
                                        },
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.rankingClickHandler(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "ui.components.products.collection_table.show_in_ranking"
                                            )
                                          ),
                                        },
                                      }),
                                      _c("span", {
                                        staticClass: "mdi mdi-open-in-new ml-2",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              item.has_product_attachments
                                ? _c("ci-product-mediathek-label")
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : field.key === "sri"
                    ? [
                        _c("span", {
                          staticClass:
                            "text-xs font-weight-semi d-block d-md-none mb-1",
                          domProps: { textContent: _vm._s(field.label) },
                        }),
                        item[field.key]
                          ? [
                              _c("ci-rating-sri", {
                                attrs: { value: item[field.key], short: true },
                              }),
                            ]
                          : [_c("span", [_vm._v("-")])],
                      ]
                    : field.key === "morningstar_rating" ||
                      field.key === "fww_rating"
                    ? [
                        _c("span", {
                          staticClass:
                            "text-xs font-weight-semi d-block d-md-none mb-1",
                          domProps: { textContent: _vm._s(field.label) },
                        }),
                        _c("ci-rating-icons", {
                          attrs: { value: item[field.key] },
                        }),
                      ]
                    : field.key === "price"
                    ? [
                        _c("span", {
                          staticClass:
                            "text-xs font-weight-semi d-block d-md-none mb-1",
                          domProps: { textContent: _vm._s(field.label) },
                        }),
                        _c("ci-price", { attrs: { prices: item.prices } }),
                      ]
                    : field.key === "performance" ||
                      field.key === "volatility" ||
                      field.key === "max_drawdown"
                    ? [
                        _c("span", {
                          staticClass:
                            "text-xs font-weight-semi d-block d-md-none mb-1",
                          domProps: { textContent: _vm._s(field.label) },
                        }),
                        item[field.key]
                          ? _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.formatPercentage(item[field.key])
                                ),
                              },
                            })
                          : _c("span", {
                              domProps: { textContent: _vm._s("-") },
                            }),
                      ]
                    : [
                        _c("span", {
                          staticClass:
                            "text-xs font-weight-semi d-block d-md-none mb-1",
                          domProps: { textContent: _vm._s(field.label) },
                        }),
                        item[field.key]
                          ? _c("span", {
                              domProps: {
                                textContent: _vm._s(item[field.key]),
                              },
                            })
                          : _c("span", {
                              domProps: { textContent: _vm._s("-") },
                            }),
                      ],
                ],
                2
              )
            }),
            0
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }